module.exports = __webpack_public_path__ + "img/icon_chatbot_onfan.1d26f0ac.svg";